const BASE_URL = "https://www.waterskerala.com/api/";
const MAIL_URL = "https://www.waterskerala.com/";
export { BASE_URL, MAIL_URL };
